<template>
  <div>
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <!-- <Toast style="margin-top: 35px" /> -->
    <form>
      <div class="p-grid">

        <div class="p-col">
          <Button class="p-button p-component p-button-success addNewBtn btn-btm-0 width-auto" @click.prevent="addDialog"
                  icon="pi pi-plus" label="Add Group"/>
        </div>
      </div>

      <Dialog header="Store Group" :visible.sync="displayAddDialog"
              s :style="{width: '40vw'}" :closable=false :modal="true">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="warehouseGroup">Warehouse Group<span style="color:red">*</span></label>
            <InputText v-model.trim="name" id="warehouseGroup"/>
          </div>
        </div>
        <template #footer>
          <Button
          class="p-button-raised" @click.prevent="addWarehouseGroup"
            :label="this.editing?'Update':'Add'"/>
          <Button class="p-button-raised p-button-info"
                  @click.prevent="addAndNewWarehouseGroup" v-if="!this.editing"
                  label="Add & New"/>
          <Button @click.prevent="cancel" class="p-button-raised p-button-danger" label="Cancel"/>
        </template>
      </Dialog>
    </form>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'warehouseGroup',
  data() {
    return {
      editing: false,
      displayAddDialog: false,
      name: '',
      id: '',
      loading: false
    }
  },
  methods: {
    async addWarehouseGroup() {
      let resp = ''
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Warehouse Group name cannot be empty!', life: 10000})
        return
      }
      let warehouseGroup = {
        name: this.name,
        id: this.id
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createWarehouseGroup', warehouseGroup)
        this.$emit('set_data_warehouse_group', resp.data.data)
        this.loading = false
        this.editing = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateWarehouseGroup', warehouseGroup)
        this.loading = false
      }
      this.responseMessage(resp)
      this.displayAddDialog = false
    },
    async addAndNewWarehouseGroup() {
      let resp = ''
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Warehouse Group name cannot be empty!', life: 10000})
        return
      }
      let warehouseGroup = {
        name: this.name,
        id: this.id
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createWarehouseGroup', warehouseGroup)
      this.$emit('set_data_warehouse_group', resp.data.data)
      this.loading = false
      this.responseMessage(resp)
    },
    editWarehouseGrp(value) {
      this.editing = true
      this.displayAddDialog = true
      this.name = value.name
      this.id = value.id
    },
    cancel() {
      this.successMessage = ''
      this.name = ''
      this.editing = false
      this.displayAddDialog = false
    },
    addDialog() {
      this.displayAddDialog = true
    },
    resetResponse() {
      this.name = ''
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.resetResponse()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    }
  },
  components: {
    Dialog,
    Button,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">

</style>



// WEBPACK FOOTER //
// warehouseGroupDialog.vue?f2b8b90a